/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiReservedLocationPageTaggerFromJSON, ApiReservedLocationPageTaggerToJSON, } from './ApiReservedLocationPageTagger';
export function ApiLocationPageTaggerPayloadFromJSON(json) {
    return ApiLocationPageTaggerPayloadFromJSONTyped(json, false);
}
export function ApiLocationPageTaggerPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'crawlSearchParams': !exists(json, 'crawlSearchParams') ? undefined : json['crawlSearchParams'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'regex': !exists(json, 'regex') ? undefined : json['regex'],
        'reserved': !exists(json, 'reserved') ? undefined : ApiReservedLocationPageTaggerFromJSON(json['reserved']),
        'selector': !exists(json, 'selector') ? undefined : json['selector'],
    };
}
export function ApiLocationPageTaggerPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'crawlSearchParams': value.crawlSearchParams,
        'name': value.name,
        'regex': value.regex,
        'reserved': ApiReservedLocationPageTaggerToJSON(value.reserved),
        'selector': value.selector,
    };
}
